import Adminpoint from '@/pages/Adminpoint/Template'
import Settings from '@/pages/Adminpoint/Settings'
import Payments from '@/pages/Adminpoint/Payments'
import Orders from '@/pages/Adminpoint/Orders'
import Notifications from '@/pages/Adminpoint/Notifications'
import Messages from '@/pages/Adminpoint/Messages'
import Events from '@/pages/Adminpoint/Events'
import Posts from '@/pages/Adminpoint/Posts'
import Stocks from '@/pages/Adminpoint/Stocks'
import Inventory from '@/pages/Adminpoint/Inventory'
import Documentation from '@/pages/Adminpoint/Documentation'
import ControlPanel from '@/pages/Adminpoint/ControlPanel'

export default {
    path: '',
    component: Adminpoint,
    children: [
        {
            path: '/settings',
            name: 'Settings',
            component: Settings,
        },
        {
            path: '/payments',
            name: 'Payments',
            component: Payments,
        },
       
        {
            path: '/orders',
            name: 'Orders',
            component: Orders,
        },
        {
            path: '/notifications',
            name: 'Notifications',
            component: Notifications,
        },
       {
            path: '/messages',
            name: 'Notifications',
            component: Notifications,
        },
        {
            path: '/events',
            name: 'Events',
            component:Events,
        },
        {
            path: '/posts',
            name: 'Posts',
            component: Posts,
        },
        {
            path: '/stocks',
            name: 'Notifications',
            component: Stocks,
        },
        {
            path: '/inventory',
            name: 'Orders',
            component: Orders,
        },
        {
            path: '/documentation',
            name: 'Documentation',
            component: Documentation,
        },
        {
            path: '/controlpanel',
            name: 'ControlPanel',
            component: ControlPanel,
        },
    ]
}


// WEBPACK FOOTER //
// ./src/router/adminpoint.js